import { useEffect, useState } from 'react';
import './droneanimation.css';

// Map the SVG part ids to human-readable names shown on hover.
const PART_NAMES = {
    frame: 'Frame',
    prop: 'Propeller',
    motor: 'Motor',
    esc: 'ESC (Speed Controller)',
    fc: 'Flight Controller',
    nut: 'Nut',
    'top-spacer': 'Top Spacer',
    'bot-spacer': 'Bottom Spacer',
    xt60: 'XT60 Connector',
    wire: 'Wiring',
    fpv: 'FPV Camera',
};

/**
 * Exploded-view drone animation.
 * The SVG artwork lives as a static asset in /public (not bundled into JS) and
 * is injected into the DOM. Hovering the drone explodes it (pure CSS); hovering
 * an individual part zooms/highlights it (CSS) and shows its name (React state).
 */
export const DroneAnimation = () => {
    const [svgMarkup, setSvgMarkup] = useState('');
    const [label, setLabel] = useState(null); // { name, x, y }

    useEffect(() => {
        let active = true;
        fetch(`${process.env.PUBLIC_URL}/droneanimation.svg`)
            .then((response) => response.text())
            .then((text) => { if (active) setSvgMarkup(text); })
            .catch(() => { /* asset missing — render nothing */ });
        return () => { active = false; };
    }, []);

    const handleMouseMove = (event) => {
        const root = event.currentTarget;
        let el = event.target;
        while (el && el !== root) {
            if (el.id && PART_NAMES[el.id]) {
                setLabel({ name: PART_NAMES[el.id], x: event.clientX, y: event.clientY });
                return;
            }
            el = el.parentNode;
        }
        setLabel((prev) => (prev ? null : prev));
    };

    return (
        <div className="drone-explode-scene">
            <div
                className="drone-explode"
                onMouseMove={handleMouseMove}
                onMouseLeave={() => setLabel(null)}
                dangerouslySetInnerHTML={{ __html: svgMarkup }}
            />
            {label && (
                <span className="drone-explode__label" style={{ left: label.x, top: label.y }}>
                    {label.name}
                </span>
            )}
            <p className="drone-explode__hint">Hover the drone to explode it — hover a part to see its name</p>
        </div>
    );
};

export default DroneAnimation;
